import { type MetricField, type MyLensesOrganicStatsResponseEntry } from "../../gql-generated/types";
import { ejectTotalMetricValue } from "../../lens-insights/filters";
import { formatNumbers } from "../formatters";

export const extractLensStatValue = (
    metrics: readonly MyLensesOrganicStatsResponseEntry[],
    metricName: MetricField,
): string => {
    const value = ejectTotalMetricValue(metrics, metricName);
    if (Number.parseInt(value) === 0) {
        return "-";
    }
    return formatNumbers(Number.parseInt(value));
};
